// Minute-precision text entry with the calendar's usual half-hour shortcuts.
export function attachTimeInput(input) {
    const wrap = document.createElement('span');
    wrap.className = 'cal-sel cal-time';
    input.before(wrap);
    wrap.appendChild(input);
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'cal-sel-btn cal-time-toggle';
    toggle.setAttribute('aria-label', input.getAttribute('aria-label'));
    toggle.setAttribute('aria-haspopup', 'listbox');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    wrap.appendChild(toggle);
    let pop = null;

    function close() {
        const closing = pop;
        pop = null; // Removing a focused option emits focusout, which may call close again.
        if (closing) closing.remove();
        toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('pointerdown', onPointer);
    }
    function validate() {
        const value = input.value.trim();
        const m = /^(\d{1,2}):([0-5]\d)$/.exec(value);
        const valid = !!m && +m[1] < 24;
        input.setCustomValidity(input.disabled || valid ? '' : input.dataset.invalid);
        input.setAttribute('aria-invalid', String(!input.disabled && !valid));
        if (valid) input.value = m[1].padStart(2, '0') + ':' + m[2];
        return input.disabled || valid;
    }
    function open() {
        close();
        pop = document.createElement('div');
        pop.className = 'cal-sel-pop';
        pop.setAttribute('role', 'listbox');
        pop.setAttribute('aria-label', input.getAttribute('aria-label'));
        const times = Array.from({ length: 48 }, (_, i) => String(Math.floor(i / 2)).padStart(2, '0') + (i % 2 ? ':30' : ':00'));
        if (/^([01]\d|2[0-3]):[0-5]\d$/.test(input.value) && !times.includes(input.value)) times.push(input.value);
        times.sort().forEach((time) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.className = 'cal-sel-opt' + (time === input.value ? ' sel' : '');
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', String(time === input.value));
            option.textContent = time;
            option.addEventListener('click', () => {
                input.value = time;
                validate();
                close();
                input.dispatchEvent(new Event('change', { bubbles: true }));
                input.focus();
            });
            pop.appendChild(option);
        });
        wrap.appendChild(pop);
        toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('pointerdown', onPointer);
        (pop.querySelector('.sel') || pop.firstElementChild).focus({ preventScroll: true });
        (pop.querySelector('.sel') || pop.firstElementChild).scrollIntoView({ block: 'nearest' });
    }
    toggle.addEventListener('click', () => pop ? close() : open());
    input.addEventListener('change', validate);
    input.addEventListener('input', () => {
        input.setCustomValidity('');
        input.removeAttribute('aria-invalid');
    });
    wrap.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && pop) {
            e.preventDefault();
            e.stopPropagation();
            close();
            input.focus();
        } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (!pop) open();
            else {
                const options = Array.from(pop.children);
                const i = options.indexOf(document.activeElement);
                options[(i + (e.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length].focus();
            }
        }
    });
    // focusout also closes the list on Tab; pointerdown catches non-focusable surfaces.
    wrap.addEventListener('focusout', (e) => { if (!wrap.contains(e.relatedTarget)) close(); });
    const onPointer = (e) => { if (!wrap.contains(e.target)) close(); };
    return { validate, close };
}
